module.exports = __webpack_public_path__ + "static/media/to-left.47da0004.svg";